import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

/**
 * This is the chat-bubble Component.
 **/
@Component({
    selector: 'ap-chat-bubble',
    templateUrl: './chat-bubble.component.html',
    styleUrls: ['./chat-bubble.component.scss'],
    imports: [NgClass]
})
export class ApChatBubbleComponent {
    /**
     * Changes the border to top right if true and changes background color
     */
    public readonly alignRight = input<boolean>(false);
}
